import { debugLog } from "../utils"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static installPromptEvent = null

  connect() {
    if (window._pwaDeferredPrompt) {
      this.constructor.installPromptEvent = window._pwaDeferredPrompt;
    }
    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault();
      this.constructor.installPromptEvent = event;
      window._pwaDeferredPrompt = event;
    });
  }

  async addToAndroidScreen() {
    const promptEvent = this.constructor.installPromptEvent

    if (!promptEvent) {
      console.warn("[PWA] No install prompt event found yet!")
      debugLog("No install prompt event found")
      alert("Your browser does not support PWA installation or the event hasn’t fired yet.")
      return
    }

    try {
      promptEvent.prompt()

      const { outcome } = await promptEvent.userChoice

    } catch (err) {
      console.error("[PWA] Error showing prompt:", err)
    } finally {
      this.constructor.installPromptEvent = null
      console.log("[PWA] installPromptEvent reset to null")
    }
  }
}
